import { AfterViewInit, Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DecimalPipe } from '@angular/common';

import { ToastrService } from 'ngx-toastr';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { DataService, CustomerService, SiteTypeService, DashboardService, VirtualTimeSeriesService, ReportService } from '../../../api/services';
import { SearchSource } from '../../../api/models/search-source';
import { SearchItem } from '../../../api/models/search-item';
import { Dashboard } from '../../../api/models/dashboard';
import { Customer } from '../../../api/models/customer';
import { TransformDetail,SiteType,Report, SiteTwin } from '../../../api/models';
import { DataAnalysisTimeSeries } from '../../../api/models/data-analysis-time-series';
import { DataAnalysisConfig, DataAnalysisItem, DataAnalysisTransform } from '../../models/data-analysis';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { OpenStreetMapComponent } from 'src/app/components/open-street-map/open-street-map.component';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { AlarmEditorComponent } from 'src/app/components/alarm-editor/alarm-editor.component';
import { DashboardComponent } from 'src/app/views/dashboard/dashboard.component';
import { DashboardSelection } from 'src/app/models/dashboard';

@Component({
  selector: 'app-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.css'],
  providers: [{ provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } }]
})
export class SiteComponent implements OnInit, AfterViewInit {
 @ViewChildren(DashboardComponent) private dashboards: QueryList<DashboardComponent>;
  siteUri: string;
  siteTypeId: number;
  site:SiteTwin;
  siteType: SiteType;
  reports: Report[];
  report: Report;
  period: string = "thisWeek";

  public columns: string[] = [];

  constructor(
    private decimalPipe: DecimalPipe,
    private dashboardService: DashboardService,
    private dataService: DataService,
    private reportService: ReportService,
    private route: ActivatedRoute,
    private app: ApplicationConfigService,
    private customerService: CustomerService,
    private vtsService: VirtualTimeSeriesService,
    private siteTypeService: SiteTypeService,
    public azureAuthService: AzureAuthService,
    private toasterService: ToastrService) {
      app.customerChanged$.subscribe(cid => {
        this.ngOnInit();
      });
  }

  getIcon(filename: string){
    if (filename.endsWith(".zip")) return "fa fa-file-archive";
    if (filename.endsWith(".pdf")) return "fa fa-file-pdf-o";
    if (filename.endsWith(".csv")) return "fa fa-file";
    if (filename.endsWith(".xls")) return "fa fa-file";
    else return "fa fa-file";
  }

  ngOnInit() {
    this.columns = [];
    this.route.params.subscribe(params => {
      this.siteUri = params["siteUri"];
      this.siteTypeId = parseInt(params["siteTypeId"]);
      if (this.app.customerId == null){
        this.app.setCustomerId(this.azureAuthService.userProfile.customerId);
      }
      if (this.app.customerId){
        this.siteTypeService.SiteTypeGetSite({customerId:this.app.customerId, siteTypeId: this.siteTypeId, siteUri:this. siteUri}).subscribe(r=>{
          this.site = r;
          this.updateReports();
          if (r){
            for (let key in r.parameters){
              var item = r.parameters[key];
              if (item.latestValue && item.latestValue){
                this.columns.push(key);
              }
            }
          }
        }, err => {
          console.error(err);
        });
      }
      this.siteTypeService.SiteTypeGetById({customerId: this.app.customerId, siteTypeId: this.siteTypeId}).subscribe(st => {
        this.siteType = st;
      });
    });
  }

  updateReports(){
    this.reportService.ReportGetData({customerId:this.app.customerId, siteUri:this.siteUri, period: this.period, timeZoneOffset: 0 }).subscribe(r => {
      this.reports = r;
    });
  }

  private dashboardsLoaded = false;
  ngAfterViewInit(): void {
    this.dashboards.changes.subscribe((components: QueryList<DashboardComponent>) => { 
      if (!this.dashboardsLoaded){
        this.dashboardsLoaded = true;
        console.log('Updated list of sub components:', components.toArray());
        setTimeout(() => {
            for (let dashboard of this.dashboards){
                (dashboard as DashboardComponent).loadWidgets();
            }
        }, 1000);
      }
    });
  }

}
